<template>
  <div class="evaluation-viewer-base">
    <div class="left-panel">
      <div class="logo">
        <img
          src="~@/assets/logo.svg"
          alt="Plataforma Five Star"
        >
      </div>
      <main>
        <h1>{{ branch.state }}, {{ branch.municipality }}</h1>
        <h2>{{ dealer.name }}</h2>
        <hr>
        <table>
          <tr>
            <td>Estatus</td>
            <td>{{ evaluation.status }}</td>
          </tr>
          <tr>
            <td>Score</td>
            <td>{{ evaluation.score }} / {{ evaluation.baseScore }}</td>
          </tr>
        </table>
      </main>
    </div>
    <div class="center-panel">
      <evaluation-viewer-top-bar :evaluation="evaluation"/>
      <scrollable-container>
        <div
          v-for="(section, $index) of evaluation.template.sections"
          :key="section.$id"
          class="evaluation"
        >
          <evaluation-viewer-section
            :index="[$index + 1]"
            :section="section"
          />
        </div>
      </scrollable-container>
    </div>
  </div>
</template>

<script>
import EvaluationHeaderInfo from '@/modules/evaluation/components/layout/evaluation-header-info'
import ScrollableContainer from '@/components/scrollable-container'
import EvaluationViewerSection from '@/modules/evaluation-viewer/components/evaluation-viewer-section'
import EvaluationViewerTopBar from '@/modules/evaluation-viewer/components/evaluation-viewer-top-bar'
/**
   * 'EvaluationViewerBase' Component
   * @version 1.0.0
   * @author Fernando Torres
   * @copyright Marciano Studio S.C., 2018
   */
export default {
  name: 'EvaluationViewerBase',
  components: {EvaluationViewerTopBar, EvaluationViewerSection, ScrollableContainer, EvaluationHeaderInfo},
  provide () {
    return {
      branchType: this.branch.type
    }
  },
  props: {
    evaluation: {
      type: Object,
      required: true
    },
    branch: {
      type: Object,
      required: true
    },
    dealer: {
      type: Object,
      required: true
    }
  },
  computed: {
    percent () {
      return parseFloat(this.evaluation.percent.toFixed(2))
    }
  }
}
</script>

////////////////////////////////////////////
//                                   STYLE
////////////////////////////////////////////
<style lang="scss">
    .evaluation-viewer-base {
      display: flex;
      width: 100vw;
      height: 100vh;
      position: absolute;
      top: 0;
      left: 0;
      overflow: hidden;
      .left-panel{
        min-width: 200px;
        max-width: 280px;
        height: 100vh;
        border-right: 1px solid #e0e0e0;
        .logo{
          margin-top: 20px;
          img{
            margin: 0 auto;
            display: block;
            height: 100%;
            min-width: 40px;
            max-width: 110px;
          }
        }
        main{
          h1{
            @include font-primary(18px)
          }
          h2{
            @include font-primary(14px)
          }
          padding: 30px;
        }
      }
      .center-panel{
        height: 100vh;
        overflow: hidden;
        flex-grow: 1;
        .top-bar{
          padding: 20px;
          border-bottom: 1px solid #dedede;
        }
        .evaluation{

        }
      }
    }
    .only-print{
      display:none;
    }

  @media print{
    .evaluation-viewer-base{
      flex-direction: column;
      overflow: auto;
      height: auto;
      .left-panel{
        max-width: 100vw;
        max-height: 100px;
        display: flex;
        justify-content: flex-start;
        align-content: center;
        border: none;
        margin: 20px 0;
        .logo{
          height: 80px;
          padding:0 40px 0 20px;
          border-right: 1px solid #c41230;
          img{
            border: 1px solid red;
            height: 100%;
          }
        }
        main{
          padding: 5px;
          h1, h2{
            margin: 0;
          }
          hr{
            display: none;
          }
        }
      }
      .center-panel{
        flex: 1;
        height: auto;
        h1{
          margin: 0;
        }
        .evaluation-viewer-top-bar{
          padding: 20px;
        }
        .evaluation-viewer-section{
          h1{
            padding: 20px;
          }
          .evaluation-viewer-question{
            padding: 20px;

            .el-checkbox__input.is-disabled.is-checked .el-checkbox__inner {
              background-color: #f2f6fc;
              border-color: #444;
            }
            .el-checkbox__input.is-disabled.is-checked .el-checkbox__inner::after {
              border-color: #444;
            }
            .el-checkbox__label{
              color: #444;
            }

            .el-switch.is-disabled {
              display: none;
            }
            .only-print{
              display: block;
              .answer-label{
                font-size: 16px;
              }
            }
          }
        }
      }
    }
    .scrollable-container{
      max-height: none !important;
    }
    .evaluation-viewer-evidence{
      display: none;
    }
    .el-dropdown{
      display: none;
    }
  }

</style>



// WEBPACK FOOTER //
// src/modules/evaluation-viewer/evaluation-viewer-base.vue